import { render, staticRenderFns } from "./GhostWriterFooter.vue?vue&type=template&id=4b5ae94f&scoped=true"
import script from "./GhostWriterFooter.vue?vue&type=script&lang=js"
export * from "./GhostWriterFooter.vue?vue&type=script&lang=js"
import style0 from "./GhostWriterFooter.vue?vue&type=style&index=0&id=4b5ae94f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ae94f",
  null
  
)

export default component.exports